// extracted by mini-css-extract-plugin
module.exports = {"loader":"MiniSpinner_loader__2UJoC","load6":"MiniSpinner_load6__miZ_e","round":"MiniSpinner_round__3ILeR"};